import { render, staticRenderFns } from "./AccountChange.vue?vue&type=template&id=442112ac&"
import script from "./AccountChange.vue?vue&type=script&lang=ts&"
export * from "./AccountChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports